import { CrlCategorizationFile, CrlItemCommentIds } from '../models';

/** Key recorded in `activeSubscriptions` while the categorization live query is open. */
export const CRL_CATEGORIZATION_SUBSCRIPTION = 'categorization';

/** Key recorded in `activeSubscriptions` while the comments live query is open. */
export const CRL_COMMENTS_SUBSCRIPTION = 'comments';

export interface CxpCrlSubscriptionsStateModel {
  /** The CRL currently subscribed to (from the route request-id param), or null. */
  requestId: number | null;
  /** Latest categorization live-query snapshot for the open request. */
  categorization: { files: CrlCategorizationFile[] };
  /** Latest comments live-query snapshot: which items have comments / unviewed ones. */
  comments: CrlItemCommentIds;
  /** Which subscriptions are currently open — controls how many live queries exist per page. */
  activeSubscriptions: string[];
}

export const DEFAULT_CXP_CRL_SUBSCRIPTIONS_STATE: CxpCrlSubscriptionsStateModel = {
  requestId: null,
  categorization: { files: [] },
  comments: { withComments: [], withUnviewed: [], latestMessageIdByItem: {} },
  activeSubscriptions: [],
};
